export const shortString = (str: string) => {
  if (str.length > 8) {
    return `${str.slice(0, 3)}...${str.slice(-4)}`;
  }
};
